import { batteryLevel } from "../constant";

export const batteryOK = (car, siteSettingsData) => {

  return siteSettingsData?.GuardianCapable && !car.IsCharging && (car.BatteryLevel > batteryLevel.warning) && (car.BatteryLevel <= 100);
};